export class Toggle {
    constructor(el) {
        this.el = el;
        this.link = this.el.querySelector(".js-toggle-link");
        this.inner = this.el.querySelector(".js-toggle-inner");
        this.openedText = this.link.dataset.openedText;
        this.closedText = this.link.dataset.closedText;
        this.initEvents();
        this.checkHeight();
    }

    initEvents() {
        this.link.addEventListener("click", () => {
            this.el.classList.toggle("opened");
            if (this.el.classList.contains("opened")) {
                this.link.innerText = this.openedText;
            } else {
                this.link.innerText = this.closedText;
            }
        });

        window.addEventListener("resize", () => {
            this.checkHeight();
        });
    }

    /**
     * Прверяет нужна ли кнопка Показать еще.
     *
     * @returns {void}
     */
    checkHeight() {
        if (!this.el.classList.contains("opened")) {
            if (this.el.offsetHeight < this.inner.offsetHeight) {
                this.link.classList.remove("hidden");
            } else {
                this.link.classList.add("hidden");
            }
        }
    }
}

document.querySelectorAll(".js-toggle").forEach(elem => new Toggle(elem));
